import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import EntryData from '../../services/entry-service';
import SocioData from '../../services/socio-service';
import PeopleData from '../../services/people-service';
import './entries.css';
var apiService = require('../../services/api-service');
var apigClientFactory = require('aws-api-gateway-client').default;


export class SubmitEntryForm extends React.Component {

  constructor() {
    super()
    this.state = {}
  }

  async componentDidMount() {
    const { accessToken } = this.props;
    try {
      const data = await SocioData.getSociogramList(accessToken);
      console.log("Data: " + JSON.stringify(data));
      this.setState({ 
        socio: data,
        empty: data == undefined ? true : false,
        selectedOption: null,
        accessToken
      });
    } catch ( err ){
      this.setState({ 
        error: true ,
        accessToken
      });
    }
  }

  peopleList = {};
  includedPeople = [];
  favourite = null;

  handlePersonCheck = event => {
    if( event.target.checked )
      this.includedPeople.push(event.target.name);
    else{
      var index = this.includedPeople.indexOf(event.target.name);
      this.includedPeople.splice(index, 1);
    }
  }

  handleSociogramSelect = async (event) => {
    var getPeople = SubmitEntryForm.getSociogramById(event.target.value, this.state.socio);
    var people = getPeople[0].people;
    const { accessToken } = this.state;
    const data = await PeopleData.queryData(people, accessToken)
    console.log("Query: " + JSON.stringify(data));
    this.setState({ 
      people: data,
      selectedOption: data[0].id
    });
    const sociogramData = await EntryData.getEntriesBySociogram(event.target.value, accessToken);
    console.log("Entries Query: " + JSON.stringify(data));
    this.setState({ 
      entries: sociogramData
    });
    return false;
  }

  handlePersonSelect = event => {
    //reset select count
    this.includedPeople = [];
    console.log("SELECTED: " + event.target.value);
    this.setState({ 
      selectedPerson: event.target.value
    });
    // auto select the second radio favourite box if the first user is selected
    console.log(event.target.value + " - " + this.state.people[0].id);
    if( event.target.value == 0 ){
      this.setState({ 
        selectedOption: this.state.people[1].id
      });
    }else{
      this.setState({ 
        selectedOption: this.state.people[0].id
      })
    }
    
    var x = document.getElementsByClassName("checkbox");
    for(var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }
    return false;
  }

  static getSociogramById(id,data) {
    return data.filter(
      function(data){ return data.id == id }
    );
  }


  static getIdByUser(entryArray, id){
    console.log("Search Array For: " + JSON.stringify(entryArray) + " FOR: " + id);
    for( var i = 0; i < entryArray.length; i++ ){
      if( entryArray[i].person == id ) {
        return entryArray[i].id;
      }
    }

  }

  handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      // Form data preparation
      const formData = {
        socioData: this.includedPeople,
        socioFavourite: this.state.selectedOption
      };
      
      // Get the selected person ID
      const selectedPersonId = SubmitEntryForm.getIdByUser(this.state.entries, this.state.people[this.state.selectedPerson].id);
      
      // Validate inputs
      if (!selectedPersonId) {
        throw new Error('Invalid selected person');
      }
      
      // Sanitize parameter
      const sanitizedPersonId = encodeURIComponent(selectedPersonId);
      
      // Set up request timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      // Make API request
      const response = await fetch(`/api/sociogram/entry/${sanitizedPersonId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${this.state.accessToken}`,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData),
        credentials: 'same-origin',
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API error: ${response.status} - ${errorText}`);
      }
      
      // Handle success
      alert("Successfully Updated Entry");
      
      // Reset state
      this.includedPeople = [];
      
      // You might want to update other state or redirect here
      
    } catch (error) {
      console.error("Error updating entry:", error.message);
      alert("Failed to update entry. Please try again.");
    }
  };

  

  handlePersonCheck = event => {
    if( event.target.checked ){
      this.includedPeople.push(event.target.value);
    } else {
      var index = this.includedPeople.indexOf(event.target.value);
      this.includedPeople.splice(index, 1);
    }
  }


  handleOptionChange = changeEvent => {
    this.setState({
      selectedOption: changeEvent.target.value
    });
  };
  
  

  render() {

    let socios = [];
    let people = [];
    let selectPeople = null;
    selectPeople = [];

    if ( this.state.empty ) {
      return (<div>No sociograms have been created yet.</div>)
    }
    
    if( !this.state.socio )
      return (<div>Waiting for data to finish loading...</div>);

    for( var i = 0; i < this.state.socio.length; i++){
        socios.push(<option value={this.state.socio[i].id}>{this.state.socio[i].name}</option>)
    }

    if( this.state.people ){
      var self = this;
      Object.keys(self.state.people).forEach(function(k){
        people.push(<option value={k}>{self.state.people[k].givenName} {self.state.people[k].surname}</option>)
      });
    }

    if( this.state.people && this.state.selectedPerson ){
      var self = this;
      for(var personToSelect = 0; personToSelect < this.state.people.length; personToSelect++ ){
        if( personToSelect != self.state.selectedPerson )
          selectPeople.push(<tr>
            <td>
              <input 
                type="checkbox"
                class={"checkbox"}
                value={this.state.people[personToSelect].id}
                onChange={self.handlePersonCheck} />
            </td>
            <td>
              {this.state.people[personToSelect].surname}
            </td>
            <td>
              {this.state.people[personToSelect].givenName}
            </td>
            <td>
              <input type="radio" value={this.state.people[personToSelect].id} name="favourite" 
                checked={self.state.selectedOption === this.state.people[personToSelect].id } 
                onChange={self.handleOptionChange} /> 
              Select as favourite. 
            </td>
          </tr>);
      };
    }

    return (
      <div>
        <h1>Submit Sociogram Entry</h1>
        <form className="form-horizontal" onSubmit={this.handleSubmit}>
          <div>
            Select Sociogram:
            <select onChange={this.handleSociogramSelect}>
              <option></option>
              {socios}
            </select>
          </div>
          <hr />
          <div>
            Select Person:
            <select onChange={this.handlePersonSelect}>
              <option></option>
              {people}
            </select>
          </div>
          <hr />
          <div>
            <div>Select connections:</div>
            <table>
              <tr>
                <td></td>
                <td><b>Last Name</b></td>
                <td><b>First Name</b></td>
                <td><b>Select as favourite</b></td>
              </tr>
              {selectPeople}
            </table>  
          </div>
          <div className="col-md-12">
            <button
              type="submit"
              className="btn btn-primary btn-block contact">
              Submit Entry
            </button>
          </div>
        </form>
      </div>
    );
  }
}


